import './qualityInspectionPopUP.css'
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import cross from '../../../images/cross.png';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import {useLocation} from 'react-router-dom';
import { useState, useEffect } from 'react';
import { authKey } from '../../../common/URLs';
import apiClient from "../../../axios";
import jwt from 'jwt-decode';
import { Container, Row, Col } from "react-bootstrap";

export const QualityInspectionPopUP = (props) => {

      
       
       
               return (
                   <div className="qualityinspection-popup-container">
                   <Container fluid>
                     <Row>
                     <p className='headingStylePIT'>Post-Inspection</p>
                       <Col xs={12} md={6}>
                          <div className="consignment-pick-up-label">Moisture</div>
                          <input className='consignment-pick-up-textfields' type="text" />
                          <div className="consignment-pick-up-label">Weight</div>
                          <input className='consignment-pick-up-textfields' type="text"/>
                          <div className="consignment-pick-up-label">Un-Restricted Inventory</div>
                          <input className='consignment-pick-up-textfields' type="text"/>
                       </Col>  
                       <Col xs={12} md={6}>
                          <div className="consignment-pick-up-label">Restricted Inventory</div>
                          <input className='consignment-pick-up-textfields' type="text" />
                          <div className="consignment-pick-up-label">Scrap Inventory</div>
                          <input className='consignment-pick-up-textfields' type="text" />
                       </Col>  
                     </Row>
                   </Container>
                   </div>
               );
         };
       